import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { acme } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

const navLinkSx = {
  fontSize: '0.875rem',
  color: acme.colors.mutedForegroundSolid,
  textDecoration: 'none',
  fontWeight: 400,
  transition: 'color 0.15s',
  whiteSpace: 'nowrap',
  '&:hover': { color: acme.colors.foreground },
};

/**
 * Acme-style top bar for authenticated app (PrivateLayout).
 * Matches MarketingNav floating pill design.
 */
export default function AppHeaderBar({ links = [], pricingHref = '/pricing', rightSlot = null, sx }) {
  return (
    <Box
      component="nav"
      sx={mergeSx(
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          borderRadius: acme.radius.md,
          backgroundColor: acme.colors.background,
          border: `1px solid ${acme.colors.border}`,
          boxShadow: acme.shadow.lg,
          py: 0.75,
          px: { xs: 1.5, sm: 2 },
          minHeight: 48,
          gap: 2,
        },
        sx,
      )}
    >
      <Box sx={{ flex: 1 }} />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, flexWrap: 'nowrap' }}>
        {links.map((item) => (
          <Box key={item.text} component={Link} to={item.path} sx={navLinkSx}>
            {item.text}
          </Box>
        ))}
        <Box component={Link} to={pricingHref} sx={navLinkSx}>
          Pricing
        </Box>
        {rightSlot}
      </Box>
    </Box>
  );
}

export { navLinkSx as appHeaderLinkSx };
